import { useEffect, useState } from 'react';

import { useIsMobile } from '../../../../../hooks';
import { GoBackButton, Preloader } from '../../../../index';

import PersonalDetailsComponent from './components/personalDetailsComponent/PersonalDetailsComponent';

import styles from './PersonalDetails.module.scss';

const PersonalDetails = () => {
  const { isMobile } = useIsMobile();

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      { loading ? (
        <div className={styles.loader}><Preloader owner="Personal Details" text="" /></div>
      ) : (
        <>
          {!isMobile && <GoBackButton />}
          <PersonalDetailsComponent />
        </>
      )}
    </>
  );
};

export default PersonalDetails;
